import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { UiOrchestratorService } from '../../core/services/ui-orchestrator.service';
import { SpecialWizard } from '../../domain/special-wizard';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SpecialWizardModalContext } from 'app/domain/special-wizard-modal-context';
import { from, Subject } from 'rxjs';
import { map, mergeMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fts-special-wizard-modal',
  templateUrl: './special-wizard-modal.component.html',
  styleUrls: ['./special-wizard-modal.component.scss'],
})
export class SpecialWizardModalComponent implements OnInit, OnDestroy {
  @ViewChild('content', { read: ViewContainerRef, static: true })
  private content: ViewContainerRef;
  public context: SpecialWizardModalContext;
  specialWizard: SpecialWizard;
  loadingContent = false;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(private uiOrchestratorService: UiOrchestratorService, private activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.specialWizard = this.context.specialWizard;
    this.uiOrchestratorService.informModalOpened();
    if (!!this.specialWizard) {
      this.loadContent();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  hideModal(shouldHide: boolean): void {
    if (shouldHide) {
      this.activeModal.close();
    }
  }

  // The wizard content is downloaded on first use, to keep the item editor out of the initial bundle
  private loadContent(): void {
    this.loadingContent = true;
    from(import('../../item-editor/editor-modal-content'))
      .pipe(
        map(({ SpecialWizardModalContentComponent }) => {
          const content = this.content.createComponent(SpecialWizardModalContentComponent).instance;
          content.specialWizard = this.specialWizard;
          content.isUpsell = this.specialWizard.isUpsell;
          content.upsellType = this.specialWizard.upsellType;
          content.featuredAreaName = this.specialWizard.featuredAreaName;
          content.featuredContentName = this.specialWizard.featuredContentName;
          this.loadingContent = false;
          return content;
        }),
        mergeMap(content => content.hideModal),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (shouldHide: boolean) => this.hideModal(shouldHide),
        error: error => {
          this.activeModal.close();
        },
      });
  }
}
